module.exports = __webpack_public_path__ + "static/media/header.cd620585.png";